<template>
  <div>

      <div class="alert-large alert-large-info"
           v-if="bookingDateIsToday
           && bookingAppearanceInPerson
           && !bookingInPersonCompleted
           && !talentCompletedInPerson
           && talentCanMarkAsCompleteInPerson">
        <div class="icon-container">
          <i class="fa fa-calendar"></i>
        </div>
        <div class="alert-content">
          <div class="row">
            <div class="col-sm-6">
              <p class="no-margin" v-if="bookingDateIsTodayExactly">
                {{
                  $userIsTalent
                    ? 'Today is the day! Once the booking is finished mark it as complete to receive your commission.'
                    : `Today is the day! Once ${user.name}'s booking is finished mark it and they'll receive their commission.`
                }}
              </p>
              <p class="no-margin" v-else>
                {{
                  $userIsTalent
                    ? 'Your booking has happened! Once the booking is finished mark it as complete to receive your commission.'
                    : `${user.name}'s booking has happened! Once the booking is finished mark it as complete and they'll receive their commission.`
                }}
              </p>
            </div>
            <div class="col-sm-6">
              <button
                class="btn btn-lg btn-success btn-job-complete"
                @click="handleMarkBookingCompleteCallback('in_person')">
                <i class="fa fa-check"></i> Mark As Complete
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="alert-large alert-large-info"
           v-if="bookingAppearanceOnline
           && !bookingOnlineCompleted
           && !talentCompletedOnline
           && talentCanMarkAsCompleteOnline">
        <div class="icon-container">
          <i class="fa fa-map-marker"></i>
        </div>
        <div class="alert-content">
          <div class="row">
            <div class="col-sm-6">
              <p class="no-margin" >
                {{
                  $userIsTalent
                    ? 'Finished your online commitment? Mark it as complete to receive your commission.'
                    : `${user.name} finished their online commitment? Mark it as complete and they'll receive their commission.`
                }}
              </p>
            </div>
            <div class="col-sm-6">
              <button
                class="btn btn-lg btn-success btn-job-complete"
                @click="handleMarkBookingCompleteCallback('online')">
                <i class="fa fa-check"></i> Mark As Complete
              </button>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { notify } from 'utils'
import { helpers } from 'mixins/bookings'
import { OpportunityTracker } from 'mixins/analytics'

export default {
  mixins: [helpers, OpportunityTracker],

  props: {
    user: {
      required: true,
      type: Object
    }
  },

  computed: {
    ...mapState('booking', ['booking']),

    talentCanMarkAsCompleteInPerson () {
      return this.booking.talent[0].response.attendance_confirmed
    },

    talentCanMarkAsCompleteOnline () {
      return this.booking.talent[0].response.online_participation_confirmed
    },

    talentCompletedInPerson () {
      return this.user.response.in_person_completed_date
    },

    talentCompletedOnline () {
      return this.user.response.online_completed_date
    }
  },

  methods: {
    ...mapActions('booking', ['getBooking', 'markBookingComplete']),

    handleMarkBookingCompleteCallback (type) {
      let payload = {
        id: this.booking.id,
        type: type,
        userId: this.user.id
      }

      return this.markBookingComplete(payload)
        .then(() => {
          notify.success('Booking has been marked as complete.')
          this.trackEvent(this.analytics.V2.JobBookingCompleteEvent)
          // Get the updated booking resource since the talent's response has changed
          this.getBooking({ id: this.booking.id })
        })
    }
  }
}
</script>
